import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import Chart from "./Chart";
import { Box, Card, CardContent, Skeleton } from "@mui/material";
import NotFound from "../../../components/notfound/NotFound";

const DashboardUnweightedIndex = () => {
  const { data = [], isLoading } = useSWR(
    "/dashboard/unweighted-index-daily",
    fetchData,
    {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000,
    }
  );

  return (
    <Card sx={{ height: 350 }}>
      <CardContent sx={{ height: "100%" }}>
        {isLoading ? <Skeleton height={"100%"} variant="rounded" />
          : !data || data.length === 0 ? (
            <Box sx={{ margin: "auto", height: "100%" }}>
              <NotFound />
            </Box>
          ) : <Chart chartData={data} />
        }
      </CardContent>
    </Card >
  );
};

export default DashboardUnweightedIndex;
